import { translateKey, type Translate } from "../../i18n/translate";

/** Codes to sentences. CMS banners print `err.message`, which for an API
 *  refusal is the CODE — a raw snake_case identifier reaching an operator is a
 *  known repeat offence in this codebase. */
const REFUSAL_KEY: Record<string, string> = {
  no_connection: "noConnection",
  capability_unavailable: "capabilityUnavailable",
  not_implemented: "notImplemented",
  breaker_open: "breakerOpen",
  credential_unavailable: "credentialUnavailable",
  credential_unreadable: "credentialUnreadable",
  unreachable: "unreachable",
  vendor_refused: "vendorRefused",
  unmapped: "unmapped",
  unknown_vendor: "unknownVendor",
  no_stay: "noStay",
  ambiguous_room: "ambiguousRoom",
  not_chargeable: "notChargeable",
  currency_mismatch: "currencyMismatch",
};

export function refusalCopy(t: Translate, code: string | null): string {
  if (!code) return "";
  const key = REFUSAL_KEY[code];
  return key
    ? translateKey(t, `premises:linkRefusalCopy.${key}`)
    : translateKey(t, "premises:linkRefusalCopy.other", { code });
}
